import { onFCP, onLCP, onTTFB } from 'web-vitals'
import mixpanelUtils from './mixpanel.utils'
import { ga4 } from '../util'

export class WebVitalsRecord {
  constructor() {
    this.mixPanelQueue = []
    this.gaQueue = []
    this.init = false
  }

  /**
   * Report metric to analytics services
   * @param {Object} metric - The metric object from web-vitals
   * @param {string} page - The page/route name
   * @param {Object} additionalData - Additional context data
   */
  reportMetric(metric) {
    const enrichedMetric = {
      metric_name: metric.name,
      metric_rating: metric.rating,
      metric_value: metric.value,
      metric_delta: metric.delta,
      metric_id: metric.id,
      metric_navigationType: metric.navigationType,
    }
    this.mixPanelQueue.push(enrichedMetric)
    this.gaQueue.push(enrichedMetric)

    // send metrics right away
    this.sendMetrics()
  }

  sendMetricsToMixpanel() {
    // only send events if mixpanel is initialized
    // and when the users are logged in
    // otherwise, MTU quota might be exceeded
    if (!mixpanelUtils.isReady() || !mixpanelUtils.isLoggedInUserIdentified()) return
    this.mixPanelQueue.forEach((metric) => {
      // Send to Mixpanel
      mixpanelUtils.track(`Web vitals > ${metric.metric_name}`, {
        ...metric,
      })
    })
    this.mixPanelQueue = []
  }

  sendMetricsToGA() {
    if (!window.dataLayer || !window.dataLayer.push) return
    this.gaQueue.forEach((metric) => {
      ga4('event', metric.metric_name, metric)
    })
    this.gaQueue = []
  }

  sendMetrics() {
    this.sendMetricsToMixpanel()
    this.sendMetricsToGA()
  }

  recordPerfEvents() {
    if (this.init) return
    const metricHandler = (metric) => { this.reportMetric(metric) }
    // Initialize all Core Web Vitals
    onFCP(metricHandler)
    onLCP(metricHandler)
    onTTFB(metricHandler)

    window.addEventListener('visibilitychange', () => {
      // fallback for when mixpanel not available
      // when metric callback
      this.sendMetrics()
    })
    this.init = true
  }
}
